import { createFileRoute } from "@tanstack/react-router";
import { DienstLocatiePage, dienstLocatieHead } from "../components/DienstLocatiePage";
import { kozijnenZwijndrecht } from "../lib/dienst-locatie-content";

export const Route = createFileRoute("/kozijnen-zwijndrecht")({
  head: () => dienstLocatieHead(kozijnenZwijndrecht),
  component: () => <DienstLocatiePage content={kozijnenZwijndrecht} />,
});
